import { render, staticRenderFns } from "./PscsNotificationItem.vue?vue&type=template&id=d65f18be"
import script from "./PscsNotificationItem.vue?vue&type=script&lang=js"
export * from "./PscsNotificationItem.vue?vue&type=script&lang=js"
import style0 from "./PscsNotificationItem.vue?vue&type=style&index=0&id=d65f18be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports